export default {
  messages: {
    approveAllRequest: "هل انت متأكد من انك تريد قبول <span class='p-base-bold'>{count}</span>؟  ؟! طلب تغير للبيانات",
    approveRequest: "هل انت متأكد من انك تريد قبول طلب التغيير الخاص بـ <span class='p-base-bold'>{field}</span>؟!",
    deleteRequest: "هل انت متأكد من انك تريد حذف طلب التغيير الخاص بـ <span class='p-base-bold'>{field}</span>!",
    deleteAllRequest: "هل انت متأكد من انك تريد حذف <span class='p-base-bold'>{count}</span>؟ طلب تغير للبيانات ؟ !",
    rejectRequest: "هل انت متأكد من انك تريد رفض طلب التغيير الخاص بـ <span class='p-base-bold'>{field}</span> ؟!",
    rejectAllRequest: "هل انت متأكد من انك تريد رفض <span class='p-base-bold'>{count}</span>؟  ؟! طلب تغير للبيانات",
    refreshTableContent: "Refresh table content",
    requestsUpdatedSuccessfully: "Request updated successfully | Requests updated successfully",
    bulkApprovePaymentConfirmation: `Are you sure you want to change the status for
<span class="text-secondary-500 p-base-bold">{numberOfRecords}</span>
payments from <span class="text-secondary-500 p-base-bold">{oldStatus}</span> to
<span class="text-secondary-500 p-base-bold">{newStatus}</span>`,
    approveAllConstraints: `Be sure to select ONLY: Cycle, Business Unit & Status filters, and
    not validated status from the status filter`,
    downloadPaymentProof: "Download Payment Proof",
    applicationSent: "تم ارسال طلب التقديم",
    noDataToDisplay: "لا يوجد بيانات للعرض",
    alreadyVerified: "لقت قمت ",
    cycleNotValidated: "This cycle isn't validated yet",

    noCommentsAvailable: "لا توجد تعليقات",
    payoutCalculationPriority: "The system will calculate the payout based on the following priority",
    uploadSignedAndSealedAgreement: "Make sure you upload only Signed & Sealed agreement",
    agreementStatusChange: "Agreement signing status will be changed to 'Signed & Sealed' upon uploading.",
    sendConfirmation: "Are you sure you want to send an agreement to the partner?",
    approvePartnerDisabled: "عقد الشريك غير موقع",
    deleteRequestRejected: "تم رفض طلب الحذف",
    unauthorized: "You are not authorized to access this page",
    emailAlreadyVerified: "تم التحقق من البريد الإلكتروني بالفعل",
    emailVerifiedSuccessfully: "تم التحقق من البريد الإلكتروني بالفعل بنجاح",
    noDataAvailable: "لا توجد بيانات متاحة",
    couponsAllocatedSuccessfully: "coupons allocated successfully",
    loading: "Loading...",
    addYourData: "افتح كل إمكانياتك! أضف بياناتك الآن لإكمال ملفك الشخصي",
    youAreDeletingTheDefaultRecord: "Are you sure you want to delete the default {type}?!",
    areYouSure: "Are you sure?!",
    workExperienceConfirmation: "أتفهم بأن منصة {appName} تتبع نموذج تقاسم الإيرادات فقط",
    nationalIDOrPassport: "National ID Or Passport",
    failedToSendID: "Failed to send verification ID request",
    confirmPartnerApproval: "هل أنت متأكد أنك تريد الموافقة على ملف الشريك؟",
    confirmPartnerRegistrationApproval: "هل أنت متأكد أنك تريد الموافقة على تسجيل هذا الشريك؟",
    confirmPartnerRejectionUndoing: "هل أنت متأكد أنك تريد التراجع عن رفض هذا الشريك؟",
    pleaseFillInMissingInfo: "أضف البيانات الناقصة",
    recordDeletedSuccessfully: "record deleted successfully",
    recordCreatedSuccessfully: "Record created successfully",
    recordUpdatedSuccessfully: "Record updated successfully",
    couponsUploadedSuccessfully: "Coupons uploaded successfully",
    applicationApprovedSuccessfully: "Application approved successfully",
    verificationIDSentSuccessfully: "Verification ID request sent successfully",
    VATDocumentSentSuccessfully: "VAT document sent successfully",
    budgetTooltip: "Budget cap is the advertising budget set for this campaign, if reached the campaign could be paused.",
    areYouSureYouWantToAllocated: "Are you sure you want to allocate {number} coupons?",
    wrongData: "Wrong data please check",
    noCouponsToSelectFrom: "There are no coupons to select from",
    noSocialMediaAccount: "No social media account",
    paymentLimitsAdded: "Payment limits added successfully",
    urlsLimitReached: "You've reached the limit for urls",
    yourPointsRedeemed: "Your points will be redeemed at the end of the month",
    rewardExtraPayment: "Your redeemed reward will be added as an extra payment",
    userAlreadyExist: "User already exists, please login",
    editUserPersonalInfo: "User's personal info updated successfully",
    revokeAccessHint: `{userName} is the assigned {bus} campaign manager. If you revoke his/her access,
    he/she will no longer be the campaign manager.`,
    editUserNotes: "User's notes updated successfully",
    onlyActiveCampaigns: "Only Active Campaigns",
    sessionExpired: "Your session has expired",
    failedToRequestDocument: "Failed to request VAT document",
    bannersUploadedSuccessfully: "Banners added successfully",
    contractSignedAndSealed: "The contract has to be signed and sealed",
    mandatoryFields: "Please fill out mandatory fields",
    editUserCampaigns: "User's campaigns updated successfully",
    youHaveReceivedAResetPasswordLink: "You have received a reset password link, check out your email",
    passwordChangedSuccessfully: "Password reset successfully",
    pleaseFixTheErrorsAndThenSubmit: "please fix the errors and then submit",
    campaignStatusUpdatedSuccessfully: "Campaign status updated successfully",
    campaignCreatedSuccessfully: "Campaign is created successfully.",
    capCreatedSuccessfully: "Cap created successfully",
    capUpdatedSuccessfully: "Cap updated successfully",
    fileUploadFailed: "File Upload Failed",
    fileUploadedSuccessfully: "File uploaded successfully",
    areYouSureYouWantToDelete: "هل انت فعلا تريد مسح ال{type}",
    editAnnouncement: "Announcement updated successfully",
    noCampaigns: "There is no campaigns",

    deleteCapConfirmation: "Are you sure you want to delete this cap?",
    discardChangesConfirmation: "Any changes made to the cap budget will not be saved. Are you sure you want to discard the changes?",
    capDeletedSuccessfully: "Cap deleted successfully",
    noteAdded: "Note added successfully",
    selectPartner: "please select a partner",
    selectCostType: "please select a cost type",
    noNotes: "No Notes",
    noNewCampaigns: "لا توجد حملات للتقديم",
    "Sorry, wrong email address or password. Please try again": "Sorry, wrong email address or password. Please try again",
    uploadFileSuccessfully: "File validated successfully",
    noValidFile: "من فضلك اختار ملف صالح",
    somethingWentWrong: "حدث خطأ",
    socialToolInfo: "اسم مستخدم ملف تعريف الوسائط الاجتماعية الخاص بك. تأكد من أن ملفات تعريف الوسائط الاجتماعية متاحة للجمهور.",
    notReady: "Sorry the payment for this month is not ready yet",
    requiredFilters: " من فضلك اختر الفلاتر التاليه: {field}",
    cycleClosedSuccessfully: "Cycle closed successfully",
    sameNumberAsWhatsApp: "نفس رقم الـ واتساب",
    agreeOn: "أنا موافق على ",
    termsAndConditions: "الشروط والأحكام",
    successfulRegistration: "شكرا لك على التسجيل!",
    successfulRegistrationMsg: "سيقوم فريقنا بمراجعة طلبك. سيتم إخطارك بالقرار عبر البريد الإلكتروني ، عادةً في غضون 2/3 أيام عمل.",

    couponsRequestSuccessfully: "تم ارسال طلبك بنجاح",
    rejectCouponsRequest: "تم رفض الطلب بنجاح",

    settingUpdatedSuccessfully: "تم تحديث الإعدادات بنجاح",
    noReleaseNotesFound: "No release notes found",
    allocateCouponsRequest: "الكوبونات تم تخصيصها بنجاح",

    invalidFile: "Incorrect file headers",
    cantAcceptNewPayment: "The payment for this month is being processed, we can't accept new payment",
    addAnnouncement: "Announcement added successfully",

    partnersWontReceive: "Partners who won't receive your announcement",
    partnersWillReceive: "Partners who will receive your announcement",
    noUpdates: "لا توجد تحديثات",
    noCoupons: "لا توجد كوبونات",
    noEarnings: "لا توجد أرباح",
    noAnnouncements: "لا توجد إعلانات",
    noPerformance: "لا يوجد أداء",

    paymentCloseWarningMsg: "هل أنت متأكد أنك تريد إغلاق دورة الدفع هذه؟",
    closedSuccess: "تم إغلاقه بنجاح",
    approvalMessage: "هل أنت متأكد من المضي قدمًا والموافقة على هذا الشريك؟",
    addNewValue: `Please note that computation happens in every 30 mins. So the {activeModule}
     values based on updated condition takes`,
    addNewValueRestMessage: "30 mins to reflect in the reports",

    cantChangeValueMessage: `You can't change the value for this date range,
     as we have already paid to the partner with this value, till {firstDate}.
     We suggest you to change End Date here till {secondDate}.
     For the remaining date range, we suggest you to add a value to create new condition and to avoid having periods without any conditions`,
    requiredDependancyFilter: "Please select {filter}",
    campaignsStatusUpdatedSuccessfully: "Campaigns set to paid successfully",

    avatarUploadedSuccessfully: "تم تحميل الصورة بنجاح",
    thereIsNoDataToDisplayInDataTable: "لا توجد بيانات لعرضها :(",
    pleaseApplyFilters: "Please, apply the filters and run the report",

    createNewAdsetConfirmation: "Are you sure you want to create {newAdsetText} Adset ?",
    updateAdsetConfirmation: "عند الموافقه ، سيتم تغيير مجموعة إعلانات القسائم إلى مجموعة الإعلانات المختارة حديثًا.",
    addAdset: "Adset added successfully",
    updateAdset: "Adset updated successfully",
    addAdsetFailed: "Failed to add Adset",
    updateAdsetFailed: "Failed to update Adset",
    youWillSendInviteByMailFor: "You will send invite by mail for",

    advertiserCreatedSuccessfully: "Advertiser created successfully.",
    advertiserUpdatedSuccessfully: "Advertiser updated successfully.",
    loginGoogleMessage: "Make sure to log in using your Arabyads account, to sign in to Boostiny",

    addNewUser: "User added Successfully",
    updatePartnerImageSuccessfully: "Update partner image successfully",
    areYouSureToContinue: `As you are not entering any value for the missing period,
        we will end up having that period without {type} condition. Are you sure to continue with that choice?`,
    noValidationsData: "There are no validations data",
    sendNotificationConfirmationMessage: `Do you want to notify
    <span class="p-base-bold text-secondary-500">partners & advertiser</span>
    on the campaign status change?`,
    updatesPending: "Thanks for the update. Partner Support team will check the update and the change will reflect after the team's approval.",
    inputChangedSuccessfully: "Input change approved",
    inputRejectedSuccessfully: "Input change rejected",
    yetToApprove: "Yet to approve",
    allEditsRequests: "All edits requests",
    maxCyclesSelected: "The max cycles selected is {number}",
    requestDuplicate: "There are more than one update for the {fields}, please choose one before approved all",
    pocHasCampaigns: "There has to be at least one campaign mapped to the client contact  to send the invite",
    SomeOfCreatedPOCsEmailExistsBefore: "Some of created client contact emails exists before.",
    confirmAAAssociateMessage: `<p class="p-base-medium"> Please note <span class="text-secondary-500"> AA Associate tag </span>
    is exclusively for a few premium publishers who are managed by AA team.
    Are you sure you want to mark <span class="text-secondary-500"> {partnerName} </span> as an 'AA Associate’ ? </p>`,
    PleaseReachOutToTheSupportTeamToClarifyTheSituationToRevertTheSuspension: `Please reach out to the Support team to clarify the situation & to
    revert the suspension: {supportEmail}`,
    areYouSureYouWantToRevertTheSuspension: "Are you sure you want to revert the suspension?",
    failedToCopy: "Failed To Copy",
    textIsCopied: "Text is copied successfully",
    backOfficeChat: "Start a new chat to connect with partners and your account managers",
    partnerChat: "Start a new chat to connect with your account managers",
    userDeletedSuccessfully: "User deleted successfully",
    confirmDeleteTeamUser: `Please make sure there are no coupons allocated to the user to delete
    the account.`,
    couponsArchivedSuccessfully: "Coupons archived successfully",
    updateCountry: "Coupon Countries Updated successfully",
    updateCountryFailed: "Failed to update country",
    updateCountryConfirmation: "On submission the Countries of the coupons will be changed to the newly selected countries.",
    confirmDeleteSheet: "Are you sure you want to delete this sheet?",
    productStats: "Product Stats",
    confirmDeletePartnerModal: "Are you sure you want to delete your account?",
    verifyOtpMessage: "Enter the OTP sent to your mail",
    verifyOtpBodyMessage: `To ensure that the account deletion is intentional and desired by you,
    we need to verify your identity. We've sent a code to`,
    timeNeedToDeletePartner: "This could take up to 4 months as we settle your pending payments.",
    supportRequestDeletePartner: `Please contact support in case you have any questions about your
    pending payments, or if you wish to recover your account.`,
    deleteIsPendingMessage: "Account deletion is on hold for the time being, as we are awaiting legal clarification. Thank you",
    cancelDeleteRequestMsg: "Are you sure you want to cancel the account deletion request?",
    otpHasBeenSentToYourMail: "OTP has been sent to your mail",
    areYouSureToDeletePromotion: "Are you sure you want to delete this promotion?",
    infoForValidationSheet: `Please note that the value of Customer_type’ should be: new, returning or NA.
    Similarly ‘Campaign_brand’ value should be {campaignCode}.
    In case the country data is not available, you may use 'NA' as value in the country field.`,
    confirmRevoke: "Are you sure you want to revoke this api token?",
    areYouSureYouWantToDeleteAllocation: "Are you sure you want to delete this allocation?",
    giveAccess: "Access has been given successfully",
    giveAccessConfirmation: "Are you sure you want to give the campaign access to {partnerName}?",
    giveAccessConfirmationTo: "Are you sure you want to give the campaign access to",
    rejectCouponRequest: `<p class="p-base-medium">Are you sure you want to reject the coupons request from
     <span class="p-base-bold text-secondary-500">{partnerName}</span>?</p>`,
    allocateCouponRequest: `<b class="text-secondary">{partnerName} - {partnerId}</b> has requested for {couponRequestCount} coupons."
     Are you sure you want to allocate {selectedCoupons} coupons {only}?`,
    deleteComment: "Are you sure you want to delete this comment?",
    archiveCoupon: "Are you sure you want to archive the selected code(s)?",
    archiveCouponNote: `Please note that once archived, the code will no longer
    be available for further allocations. Code will be expired for respective partner.
    Existing allocations to BU, TL, TM & Traffic source will remain the same.
    Conversion details in Reports will remain as normal.`,
    referralByPartner: "Refered by an already {appName} partner?",
    refferedBy: "Referred by: {partnerName}",
    confirmSingleRedeem: "Are you sure you want to redeem this prize to the selected partner?",
    confirmBulkRedeem: "Are you sure you want to redeem the prizes to the selected partners?",
    noActiveCampaigns: "You have no active campaigns in the Boost & Earn",
    topPartnersMsg: "Top partners will appear here",
    noRedeemPoints: "you have No redeem points",
    canNotChangeCampaignType: `Make sure you select the correct kind of campaign
    (<span class="p-base-bold">Coupon</span> or <span class="p-base-bold">Link</span>). This can’t be modified later on.`,
    addOfferUrl: `Add the offer URL and select the macros required from the advertiser with the
    right format from Boostiny macros. Uncheck any extra queries added from the link that is not a macro`,
    canUpdateMacros: `You can update the macros by changing the <span class="p-small-bold">“Advertiser sent link”</span>
        and clicking the <span class="p-small-bold">“Add”</span> button`,
    hitAddToUpdateMacros: "Hit “Add” after you insert the offer link above to update macros",
    linkWithUpdatedMacros: "Link with the updated boostiny macros",
    customizeYourLink: "Customize your link by selecting the needed parameters from the following.",
    userSourceMessage: "Helps you to aggregate data by the traffic source value in the reports",
    userClickIDMessage: "Helps you to reference individual clicks across tracking systems",
    subIdsMessage: "Helps you to aggregate data by non-unique ID values  (Eg, keyword, subsite, etc.) in the reports",
    trackingLinkCreated: "The new tracking link created successfully",
    searchAfter10Chars: "Please enter at least 10 chars",
    totalConversionsRecorded: "This is the total conversions recorded for the above Clicks for the lifetime.",
    deleteCommission: "Are you sure you want to delete this commission class?",
    referralMessage: `•You’re invited to join Boostiny {bu}
    by {partner} \n•Referral Code: {code} \n•Referral Link: {domain}?code={code}`,
    searchInMessages: "Enter at least 3 characters to start the search",
    duplicatedGroup: "Another group already has the same conditions",
    recordEditedSuccessfully: "Record edited successfully",
    isAovOrOrderSelected: "Category dimension is disabled as you’re using AOV/Order dimension",
    isCategorySelected: "AOV/Orders dimension is disabled as you’re using Category dimension",

    categoryDeletedSuccessfully: "Category Deleted Successfully",
    categoryCreatedSuccessfully: "Category Created successfully",
    noCommissionMessage: "You have no active commissions please contact Account Manager",
    noDailyTipsMsg: "There are no daily tips added",
    areYouSureToDeleteDailyTip: "Are you sure you want to delete this tip?!",
    deleteTipSuccessfully: "Tip Deleted Successfully",
    undoValidationConfirmation: "Are you sure you want to undo the 'Approved' status of Campaign Validation of {campaignName} for {date}?",
    undoValidationSuccessfully: "Campaign validation has been reset",
    confirmDeleteAnnouncement: `Are you sure you want to delete this announcements.
    Once deleted, partners will no longer be able to see this content?`,
    deleteAnnouncementSuccessfully: "Announcement Deleted Successfully",
    deepLinkMessage: `Helps you to redirect customers to specific category/product pages in the client site.
      Make sure you enter URLs from this client’s website itself.`,
    defaultDeepLinkMessage: `If the partner is not adding any deeplink parameter, the user will land on this URL.
    Also, partners can only add deeplink URLs that belong to this domain.`,
    deepLinkNotSameDefaultDeepLink: "Make sure you only add deeplink URLs that belong to this domain.",
    noDataToExport: "No Data to export",
    agencyPartnersHint: "Conversions & Sale Amount in below table are the last month’s performance for each partner",
    globalCommissionRuleCalculation: "Global commission rule is calculated only when there are no <span class='p-base-bold'>defined rules.</span>",
    payoutValueMaximum: "Should be 40% of the defined revenue value",
    globalRuleTooltip: "Will be calculated in case there are no defined rules.",
    maxSelectedValues: "Max selected values is {max}",
    selectDateRange: "Please select date range",
    fillRequiredFields: "Fill required fields correctly",
    postbackRequestsError: "{percentage} of the requests have been rejected/caused an error",
    confirmDeleteZohoAgreement: "Are you sure you want to delete the current contract? A backup will be saved",
    confirmDeleteManualAgreement: "Are you sure you want to delete the current contract?",
    budgetCapMsg: "Budget Cap is calculated based on the campaign gross revenue or gross conversions.",
    currencyExchangeSupportText: `Setting preferred currency enables you to view
    Boostiny Reports in that currency but the original currency is US Dollar`,
    currencyExchangeHint: "The exchange rate is relative to the dollar.",
    currencyExchangeDisclaimer: `Currency exchange rates is supported via live rates
    Currency Exchange API and updated every 24 hours for the supported currencies.`,
    deletePostBackURL: "Are you sure you want to delete this postback URL?",
    brandCreatedSuccessfully: "Brand created successfully",
    brandUpdatedSuccessfully: "Brand updated successfully",
    branddeletedSuccessfully: "Brand deleted successfully",
    confirmDeleteBrand: "Are you sure you want to delete this",
    selectAdvetiserMsg: "Please, select an advertiser first",
    definedTargetedMessage: "Defined in targeted countries, you’re not allowed to block it",
    selectAllowOrBlockedCountries: "Select the countries you want to allow or block traffic from, leaving it empty will allow traffic from anywhere",
    definedBlockedMessage: "Defined in blocked countries, you’re not allowed to target it",
    partnersAndAdvertisersCurrencyChangeDisclaimer: `{currency} currency exchange rate is
    applied on current live rate it might be different than your invoices`,
    backOfficeCurrencyChangeDisclaimer: "{currency} currency exchange rate is applied on current live rate",
    currencyFilterDisclaimer: "Please enter value in USD",
    pleaseSelectBUAndCycle: "Please select business unit and payment cycle",
    updateStatusConfirmation: "Are you sure you want to update the selected record | Are you sure you want to update the selected {n} records",
    updateStatusConfirmationSecondPart: "status to {status}?",
    updateApprovedAndDelayedConfirmation: "Partner payment below $ {limit} cannot be paid",
    remainingUnvalidatedPartners: `Some partners are still pending status change in validation
    'Not Validated', please check validation status update first`,
    automaticallyDelayedPartnersHint: `{number} out of {total} Partners payment are below
    $ {limit} cannot be paid, and these {number} partners will be delayed automatically`,
    noResolvedComments: "There are no resolved comments",
    noActiveComments: "There are no active comments",
    youCanMentionUsers: "You can mention others by adding (@) before name",
    addNewComment: "Add New Comment",
    updateDelayAndHideConfirmation: `The selected payment will be delayed according to BI team request
    | The selected payments will be delayed according to BI team request`,
    createGlobalPayout: "New Payout added successfully",
    editGlobalPayout: "Payout updated successfully",
    deleteGlobalPayout: "Global payout deleted successfully",
    alertGlobalPayout: "Some campaigns are validated in the defined date period, you’re only able to edit end-date to ",
    confirmDeleteGlobalPayout: "Are you sure you want to delete this global payout?",

    pendingVatInvoice: "الرجاء رفع فاتورتك الضريبية لإتمام عملية الدفع",
    pendingAcceptance: "الرجاء قبول فاتورتك لإتمام عملية الدفع",
    underReview: "فريقنا يقوم بمراجعة فاتورتك الضريبية الآن",
    processing: "فاتورتك قيد التنفيذ وسوف يتم دفعها في أقرب وقت",
    rejectedByTheBank: "لقد تم رفض فاتورتك من قبل البنك ، الرجاء التواصل مع فريق الدعم للمساعدة",
    delayed: "لقد تم تأجيل فاتورتك وسوف تضاف لفاتورة الشهر القادم",

    areYouSureToAcceptInvoice: "هل انت متأكد انك تريد قبول الفاتوره؟!",
    areYouSureToRejectInvoice: "هل انت متأكد انك تريد رفض الفاتوره؟!",

    requestSentSuccessfully: "لقد تم ارسال طلبك بنجاح",
    partnerVatRegisteredSupportText: "الرجاء العلم أنه يجب رفع الفاتورة الضريبية لإي فاتورة قيد التنفيذ بقيمة مستحقاتك لإتمام عملية الدفع",
    noSavedFilters: "You have no saved filters yet, create a filter and save it",
    recordSavedSuccessfully: "Filters saved successfully",
    maxCharsLimit: "Maximum 40 characters",
    filtersGroupsLimitExceeded: "You exceed the limit for the allowed saved filters group, please delete some of them to be able to add new ones",
    deleteFilterConfirmation: "Are you sure you want to delete {filter} ?!",
    stopBanner: "Are you sure you want to stop this banner?",
    removeBanner: "Are you sure you want to remove this banner?",
    bannerRemovedSuccessfully: "Banner removed successfully",
    bannerStoppedSuccessfully: "Banner stopped successfully",
    thereIsNoDataToBeExported: "There is no data to be exported",
    pushNotifications: "Turn on to receive alerts for notifications",
    activeCouponsHint: "Active coupons are allocated coupons on active campaigns",
    pausedCouponsHint: "Paused coupons are allocated coupons on paused/stopped campaigns",
    inactiveCouponsHint: "Inactive coupons are past allocated coupons",
    undoFileUpload: "Are you sure you want to undo this file upload?",
    undoFileUploadWarning: `Please note that the undo action will remove {records} record |
    Please note that the undo action will remove {records} records`,
    fileDeletedSuccessfully: "File deleted successfully",

    noValidationErrors: "No validation errors",
    partnerRevokementWarning: "عذرا حيث ان روابط التتبع لديك على هذه الحملة قد تم ايقافها من تاريخ {date} بسبب {reason}",
    partnerRevokementWarningOtherReason: "عذرا حيث ان روابط التتبع لديك على هذه الحملة قد تم ايقافها من التاريخ {date} بسبب:",

    deactivationHint: {
      links: "Links from",
      campaign: "on campaign",
      activityPaused: "will be broken & activity will be paused",
    },
    campaignRevokementReason: "Reason for deactivating the links, this reason will be shared with the partner",
    accessRevokedSuccessfully: "Access revoked successfully",
    pleaseNoteTheFollowing: "Please note The following",
    customerTypeValue: "Customer type value",
    customerTypes: "New, Returning, or NA",
    shouldBe: "should be",
    campaignBrandValue: "Campaign brand value",
    inCaseCountryNotAvaliable: "In case the country data is not available you may use NA as value in the country field.",
    acceptValidationSheet: "Are you sure you want to accept the uploaded Validation Sheet?",
    undoValidationSheet: "Are you sure you want to undo the uploaded Validation Sheet?",
    flagValidationSheet: "Are you sure you want to flag the uploaded validation sheet?",
    maxCharacter: "Max. {num} character",
    rejectUploadedSheetHint: "You’re about to reject the uploaded validation sheet",
    selectAtLeastOneReason: "Please select at least one reason",
    pleaseSelectCampaign: "Please Select Campaign",
    entitiesCountriesWarning: "You must allocate all remaining countries on a new entity, or select all countries for this one.",
    reviewEntities: "Review entities before you proceed",
    pleaseSelect: "Please select {fields}",
    useInfoForInvoice: "قم باستخدام هذه المعلومات في فاتورتك الضريبية التي ستقوم برفعها",
    noInvoices: "No new invoices at the moment.",
    invoicesAppearHere: "All your invoices will appear here.",
    approvePaymentConfirmation: "Are you sure you want to approve the selected record? | Are you sure you want to approve the selected {n} records?",
    autoAcceptInvoicesHint: "مستحقاتك سيتم الموافقة عليها تلقائيًا بعد ٧ ايام في حال عدم اتخاذ أي إجراء من جانبكم",
    notAuthorized: "You are not authorized to access this page",
    roleUpdatedSuccessfully: "Role updated successfully",
    userPermissionsUpdatedSuccessfully: "User permissions updated successfully",
    thankYouForContactingBoostiny: "Thanks for contacting Boostiny!",
    weWillContactYouShortly: "We will be in touch with you shortly.",
    haveAGreatDay: "Have a great day!",
    linkCopied: "Link Copied",
    userHasPendingRequest: "لا يمكنك طلب كوبونات حيث لديك بالفعل طلب قيد المراجعة",
    requestValueRange: "يمكنك طلب كوبونات بين {min} إلى {max}",
    noReleaseNotes: "There are no release notes",
    releasePublished: "This release is already published.",
    clickToAddNewSection: "Click to add new to add new {section}",
    couponsUnarchivedSuccessfully: "Coupons unarchived successfully",
    UnarchiveCouponsHint: `Unarchiving the coupons doesn’t guarantee retrieving the old gross numbers
    , but any new conversion will be added to Boostiny.`,
    cantCreateRelaseNote: "There is a scheduled release note, you can't create a new one",
    releasePublishTimeHint: "If the release publish time is not set, the release note will published automatically.",
    iconnectTeamHint: `Please note that selected coupons will be
    allocated to unallocated INF team leader and unallocated INF account manager`,

    archivedCouponUpdatedSuccessfully: "Archived coupon updated successfully",
    confirmDeleteSelectedUser: "Are you sure you want to delete current user",
    deleteUserHint: "Also note that the deleted users mail id can't be used again for another user",
    addRequiredFieldFirst: "Please select {keys} first",
    ignoreCouponHint: "Are you sure you want to ignore the selected code(s)?",
    restoreCouponHint: "Are you sure you want to restore the selected code(s)?",
    pleaseNote: "Please Note",
    accessListedLinkCampaigns: "'s access on the listed link campaigns will be revoked and",
    willGrantAlternativeClonedAccess: "will grant alternative cloned access.",
    totalNumOfAllocations: "Total number of allocations will be reallocated to",
    onTheListedCouponCampaigns: "on the listed coupon campaigns.",
    teamLeaderAccessCampaigns: "and his team members' access on link campaigns will be revoked from the listed link campaigns and",
    teamMembersGrant: "and his team members will grant alternative cloned access",
    willReallocatedTo: "coupons will be reallocated to",
    unAllocatedAccountManager: "and Unallocated Account Manager.",
    validationMigrateErrorMsg: "This campaign is validated in {lastValidatedCycle}, and the minimum valid date is {minValidDate}",
    allocationMigrateErrorMsg: "There are active allocations after the selected start date.",
    actionCannotReverted: "Please note that this action cannot be reverted, are you sure you want to continue?!",
    changeReportingLineFor: "Please Note changing the reporting line for",
    willReallocate: "will reallocate",
    couponsAllocationOn: "coupons allocations on",
    campaignsTo: "campaigns to",
    willSet: "will set",
    couponsAllocationsOn: "coupons allocations on",
    campaignsToUnAllocatedAccountManager: `campaigns to be unallocated account manager depending on each
    allocation business unit & and revoke the user’s access to`,
    linkCampaigns: "link campaigns",
    differentTeamAllocationHint: "Please note: coupons will be allocated to unallocated INF team leader",
    accessMigrateErrorMsg: "Link campaigns cannot be migrated before {value} for media-buying users",
    noAffectedCampaigns: "No Affected Campaigns",
    areYouSureYouWantToApprovePartner: "Are you sure you want to update the selected partner(s) status to approved?",
    areYouSureYouWantToPendingPartner: "Are you sure you want to update the selected partner(s) status to pending?",
    partnerChangedToPendingSuccessfuly: "Partner’s validation changed to pending successfully",
    partnerChangedToApprovedSuccessfuly: "Partner’s validation approved successfully",
    sendValidationSummariesToFinance: "Are you sure you want to send the selected validation summaries to Finance?",
    emailSentSuccessfully: "Email sent successfully",
    delayedUponBIRequest: "Delayed according to BI team request",
    partnerDataFetchError: `Influencer data has not been requested from IDH yet. If this error persists for more than 24 hours,
    please raise a support ticket.`,
    percentageValue: "Note: The value should be between 1 to 100",
    minValue: "Note: The minimum value is {min}",
    maxValue: "Note: The maximum value is {max}",
    minMaxValue: "Note: The value should be between {min} to {max}",
    cannotRevokeCGTeamAccess: "You can't revoke access from the assigned CG team member",
    zeroConversionsForXDays: "After Coupon allocation, there are zero conversions for X consecutive days",
    turnOnToReceiveEmailAlertsAroundPerformanceOfCoupons: "Turn on to receive email alerts around performance of coupons",
    emailNotificationsUpdatedSuccessfully: "Email Notifications updated successfully",
    contactUrBankToGetInfo: "Contact your bank to get this info",
    thereAreCouponsAllocatedToUser: "هناك كوبونات مخصصة أو سيتم تخصيصها للمستخدم، يرجى التأكد من إلغاء تخصيصها أو إعادة تخصيصها.",
    approvalConfirmation: "Are you sure you want to approve this partner's application?",
    requiredDimensions: "{dimensions} dimension is dependant on this metric | {dimensions} dimensions are dependant on this metric",
    undoValidation: "Are you sure you want to undo the validation?",
    linkCopiedSuccessfully: "Link copied successfully",
    unableToFetchData: "Unable to fetch data",
    irregularPayouts: "have greater payouts than revenue.",

    partnerCampaignsStats: "الحملات النشطة التي تحتوي على كوبون واحد على الأقل مخصص لك",
    partnerCouponsStats: "{activeAssignedCoupons} كوبون فعال من أصل {totalAssignedCoupons}",
    noCouponsAvailable: "No coupons Available",
    maxNumOfSelectedCoupons: "The max number of coupons allowed is 20",
    cantSelectMoreThan20Coupons: "You can’t select more than 20 coupons",
    hasNoCouponsSelected: "You don't have selected coupons, please go back to the coupons list and select coupons to allocate",
    noCouponsSelectedToBeAllocated: "No Coupons selected to be allocated.",
    goBackToCouponsListToAllocate: "Please go back to the coupons list and selected coupons to allocate.",
    couponsWillUpdated: "Coupons allocation will be updated",
    couponsHaveNoUpdates: "Coupons have no updates",
    couponsWillNotUpdated: "Coupons allocation cannot be updated",
    couponsRequireChange: "Coupons require the above change",
    invalidData: "Invalid data",
    givenDataIsInvalid: "The given data is invalid",
    blockedAllocationMessage: `Changing the {changedFields} for the selected coupons will affect the {affectedFields},
     so please go back and select the required missing changes in order to proceed.`,
    invalidAllocationChanges: "Invalid Allocation Changes",
    validationOutPutDescription: "Please note the following validation output for your changes",
    internalTeamAllocationDisableHint: "You cannot change the internal team allocation for Iconnect team coupons",
    partnerAllocationDisableHint: "You cannot change the partner allocation for Iconnect team coupons",
    pleaseSelectTeamFirst: "Please be sure to select team first.",
    pleaseSelectBuFirst: "Please be sure to select business unit first.",
    noTeamLeadersOperateOnSelectedBus: "There are no team leaders are operating on the selected business units",
    noTeamMemberOperateOnSelectedBus: "There are no account managers are operating on the selected business units",
    allocationActionError: "Please make some changes or toggle off this action.",
    areYouSureToCancelAllocationProcess: "Are you sure to cancel the allocation process?",
    clickToUpload: "Click to upload",
    orDragAndDrop: "or drag and drop",
    couponsWillBeAllocated: "Coupon will be allocated | Coupons will be allocated",
    invalidCoupons: "Invalid Coupon | Invalid Coupons",
    couponsAlreadyAllocated: "Coupon already allocated | Coupons already allocated",
    isAllocatedTo: "is allocated to",
    and: "and",
    couponArchive: {
      isArchivedBy: "is archived by",
      at: "at",
    },
    uploadedSheetContains: "The uploaded sheet contains",
    cancelConfirmation: "Are you sure you want to leave? You have some unsaved changes.",
    selectBuToChangeTeamValue: "Please select business unit value to be able to modify the team value",
    selectTLToChangeTMValue: "Please select team leader value to be able to modify the team member value",

    approveAllPartners: "Are you sure you want to approve the validation for all partners?",
    partnerValidationRequestReceived: "Partner Validation Request is received and you will be notified via email once the action is completed",
    invalidInvoicingNumbers: "Invalid number(s) ({numbers}) in the range from {from} to {to}",
    noDataSelectedToProceed: "No data selected to proceed",
    goBackToClientsInvoicingListToProceed: "Go back to the clients invoicing list to proceed",
    undoCampaignInvoice: "Are you sure you want to undo this campaign invoice?",
    invoiceReviewedSuccessfully: "Invoice reviewed successfully",
    reviewCampaignInvoice: "Are you sure to mark this invoice as reviewed?",
    startInvoicingCTA: "Be sure to select legal entity and invoices records to start invoicing",
    passwordUpdated: "Your password has been successfully updated",
    partnerApproved: "Partner approved successfully",
    partnerRejected: "Partner rejected successfully",
    invoicesGeneratedSuccessfully: "Invoices generated successfully",
    forVatUnregisteredPartnersWouldYouLike: "For vat unregistered partners would you like to:",
    socialMediaProfilePubliclyAccessible: "Make sure your social media profile is publicly accessible",
    invitationSentSuccessfully: "تم إرسال الدعوة بنجاح",

    basicInformationStepMsg: "الحد الأدنى من المعلومات الأساسية لبدء محادثة شخصية معك",
    emailVerificationStepMsg: "لقد تم إرسال رمز التحقق إلى بريدك الإلكتروني",
    socialMediaStepMsg: "إضافة حساباتك على وسائل التواصل الاجتماعي يساعدنا في تحديد مدى تأثيرك واقتراح الحملات المناسبة لك. تأكد من أن حساباتك عامة",
    businessExperienceStepMsg: "أخبرنا عن تجربتك",
    trafficSourcesStepMsg: "إضافة مصادر الزيارات الخاصة بك يساعدنا في تحديد مدى تأثيرك واقتراح الحملات المناسبة لك",
    preferencesStepMsg: "اقتربت من الانتهاء! تبقى بعض الأسئلة",

    bySigningUpYouAgreeWith: "من خلال إنشاء حساب، فإنك توافق على {appName}",
    privacyPolicy: "سياسة الخصوصية",
    notPublisher: "لست ناشراً؟ً",
    signUpToRevgate: " قم بإنشاء حساب على منصة RevGate إذا كنت",
    notPublisherSignupHintMsg: "من المؤثرين ولديك العديد من المتابعين على وسائل التواصل الاجتماعي",
    notInfluencer: "لست مؤثراً؟",
    signUpToBoostiny: "قم بإنشاء حساب على منصة Boostiny إذا كنت",
    publisherSignUp: "من الناشرين",
    notInfluencerSignupHintMsg: "الذين يروجون لمنتجات أو خدمات من خلال المواقع الإلكترونية أو تطبيقات المحمول أو إذا كنت تدير حملات الميديا باينج",
    inputFlagged: "This {input} is flagged",
    inputHasEditRequests: "This {input} has edit requests",
    partnerDataUpdatedSuccessfully: "تم تحديث بيانات الشريك بنجاح",
    useStrongPassword: "نوصي باستخدام كلمة مرور قوية للحفاظ على أمان حسابك",
    partnerPasswordCreated: `تم إنشاء كلمة المرور بنجاح. يمكنك الآن الوصول إلى {appName}
      وأكمل ملفك الشخصي مع التفاصيل الأساسية لبدء عملك`,
    agencyPasswordCreated: "You've created your password successfully. You can now access {appName}.",
    advertiserPasswordCreated: "You've created your password successfully. You can now access {appName}.",
    createPasswordInvalidTokenHint: `!انتهت صلاحية الصفحة التي تحاول عرضها لأسباب أمنية،
     ولكن يمكنك التواصل بفريق دعم الشركاء بسهولة للحصول على دعوة جديدة وإنشاء كلمة مرور. لا تتردد، تواصل معنا`,
    completeProfileInfo: "خطوة واحدة تفصلك عن بدء العمل معنا",
    completeProfileInfoHint: "أكمل ملفك الشخصي لنوفر لك تجربة سلسة، ولنساعد فريقنا على معالجة طلبك والانطلاق معك في أقرب وقت",
    invalidTokenHint: `رابط الدعوة الذي تحاول استخدامه غير صالح، ولكن يمكنك بسهولة
     التواصل مع فريق دعم الشريك الخاص بنا للحصول على دعوة جديدة وإنشاء كلمة مرور. لا تتردد، فقط اطلب!`,
    profileReviewStatus: "خطوة أخيرة! يتم الآن التحقق من ملفك الشخصي",
    profileReviewStatusHint: "نحن نتحقق من بياناتك بعناية، وبمجرد الموافقة عليها، سننتقل إلى الاتفاقية لنبدأ العمل معًا!",
    accountHolderNameHintMsg: "الاسم الكامل للحساب البنكي",
    confirmSubmitProfileCompletionDataInProfile: `يرجى ملاحظة أنه بعد التقديم لن تتمكن من تحديث معلومات الدفع الخاصة بك أو
     المستندات الرسمية وسيتم إرسال ملفك الشخصي للمراجعة.`,
    dataUpdatedSuccessfully: "تم تحديث البيانات بنجاح",
    noEditRequests: "لا توجد طلبات تعديل",
    youDontHaveAccessToUnselectCampaign: "ليس لديك حق الوصول لإلغاء تحديد هذه الحملة",
    invitePocHintMsg: "لدى المستخدم رمز دعوة بالفعل، هل تريد إرسال رمز آخر؟",
    thereIsNoTrafficSources: "لا يوجد أي مصدر للزيارات",
    noItemsInThisSource: "لا توجد عناصر في هذا المصدر",
    pendingRequestsWillBeDeleted: `التغييرات التي أجريتها ستؤدي إلى حذف طلب تغيير البيانات المعلق على {inputs}، هل أنت متأكد أنك تريد المتابعة؟ |
     التغييرات التي أجريتها ستؤدي إلى حذف طلبات تغيير البيانات المعلقة على {inputs}، هل أنت متأكد أنك تريد المتابعة؟`,
    selectedDatesMsg: "تم اختيار {length} {type}",

    cannotAcceptInvoiceAfterAllowedDays: "لا يمكنك قبول هذه الفاتورة — لقد انتهت فترة السماح البالغة 7 أيام.",
    actionWillAffectCGTargets: "This action will affect the CG Team's campaign targets.",
    changingCGMWillAffectCGTargets: "Changing the CGM will affect the CG Team's campaign targets.",
    deletePartnerTarget: "Are you sure you want to delete the {partner}'s target?",
    trendFamCampaignsAreExcluded: "TrendFam campaigns are not included",
    pleaseSelectCGD: "Please select CGD",
    targetsWillBeAdded: "Targets will be added",
    targetsWillBeUpdated: "Targets will be updated",
    invalidTargets: "Invalid targets",
    pleaseSelectDepenciesFilters: "Please select {filters}",
    deleteCampaignTarget: "Are you sure you want to delete {name} campaign target and the assigned targets to the team?",
    noTargetAdded: "No Target Added",
    numOfInvalidRecords: "invalid records",
    numOfUpdatedRecords: "records will be updated",
    numOfSetCampaigns: "new campaigns' targets will be set",
    pleaseSelectAPlatform: "يرجى اختيار منصة",
    pleaseSelectInstagramPlatform: "يرجى اختيار منصة إنستغرام",
    pleaseSelectInstagramYoutubeTiktokPlatforms: "يرجى اختيار منصة إنستغرام أو يوتيوب أو تيك توك",
    partnerHasNoAccounts: "هذا الشريك ليس لديه حسابات",
  },
}
